import type { User } from '../types'

type RoleUser = Pick<User, 'role' | 'admin_type'> | null | undefined

export function isReferentEko(role: string | null | undefined): boolean {
  return role === 'referent_eko'
}

export function isItAdminUser(user: RoleUser): boolean {
  return user?.role === 'admin' && user.admin_type === 'spravce_it'
}

/** Přístup k funkcím hlavního ekonoma (FKSP ekonom, cestovní příkaz — panel ekonoma, …). */
export function hasFinancistAccess(user: RoleUser): boolean {
  if (!user?.role) return false
  if (isItAdminUser(user)) return true
  return user.role === 'financist' || user.role === 'referent_eko'
}

/**
 * Legacy / seed ACL pro evidenci IT majetku (dokud IT neuloží vlastní seznam).
 * Runtime kontrola: GET /it-assets/access.
 */
export function canAccessItAdminRestrictedTable(user: RoleUser): boolean {
  if (!user?.role) return false
  if (user.role === 'admin' && (user.admin_type === 'spravce_it' || user.admin_type === 'spravce_budov')) {
    return true
  }
  if (user.role === 'property_referent') return true
  if (user.role === 'financist' || user.role === 'referent_eko') return true
  if (user.role === 'director') return true
  return false
}

/** Přístup k workflow obchodního referenta v žádankách o nákup. */
export function hasPurchaseReferentAccess(user: RoleUser): boolean {
  if (!user?.role) return false
  if (isItAdminUser(user)) return true
  return user.role === 'referent' || user.role === 'financist' || user.role === 'referent_eko'
}
